import { Box, Typography } from "@mui/joy";

const PlanCartBox = ({ selected, calculateFinalPrice, upgradeDiscount }) => {
    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
            >
                <Box minWidth={300}>
                    <Typography level="body-md">
                        {selected?.state?.label}
                    </Typography>
                    <Typography level="body-sm" color="neutral">
                        {selected?.state?.price_display}{" "}
                        {selected?.state?.billing_description}
                    </Typography>
                    <Typography level="body-sm" color="neutral">
                        {selected?.state?.details}
                    </Typography>
                </Box>
                <Box minWidth={80} textAlign="right">
                    <Typography level="body-sm" fontWeight="lg">
                        {selected?.state?.price_amount}€
                    </Typography>
                    {calculateFinalPrice() < selected?.state?.price_amount ? (
                        <Typography color="red" level="body-sm" fontWeight="sm">
                            -
                            {Number(
                                upgradeDiscount()).toFixed(2)}
                            €
                        </Typography>
                    ) : null}
                </Box>
            </Box>
        </>
    );
};

export default PlanCartBox;
